import type {
  TClass,
  TFase,
  TFaseGroup,
  TLevel,
  TSchoolLevel,
} from 'types/classAndPhases'

export const getClassesByPhase = (phases: TFase): TClass[] => {
  let classes = []
  if (phases === 'Fondasi') {
    classes = [...classes, 'PAUD']
  }
  if (phases === 'A') {
    classes = [...classes, 'Kelas 1', 'Kelas 2']
  }
  if (phases === 'B') {
    classes = [...classes, 'Kelas 3', 'Kelas 4']
  }
  if (phases === 'C') {
    classes = [...classes, 'Kelas 5', 'Kelas 6']
  }
  if (phases === 'D') {
    classes = [...classes, 'Kelas 7', 'Kelas 8', 'Kelas 9']
  }
  if (phases === 'E') {
    classes = [...classes, 'Kelas 10']
  }
  if (phases === 'F') {
    classes = [...classes, 'Kelas 11', 'Kelas 12']
  }
  return classes
}

export const getLevelsByPhaseAndPhaseGroup = ({
  selectedFase,
  selectedFaseGroup,
}: {
  selectedFase: TFase
  selectedFaseGroup: TFaseGroup
}): TLevel => {
  let level: TLevel

  if (selectedFase === 'Fondasi') level = 'PAUD'
  if (['A', 'B', 'C'].includes(selectedFase)) level = 'SD'
  if (selectedFase === 'D') level = 'SMP'
  if (['E', 'F'].includes(selectedFase)) {
    level = selectedFaseGroup === 'SMK' ? 'SMK' : 'SMA'
  }

  return level
}

const phaseGroupPostFix: Record<TFaseGroup, string> = {
  Umum: '/sederajat',
  SMK: '',
  SLB: 'LB',
}

export const getSchoolLevel = (selectedFase, selectedFaseGroup) => {
  const level = getLevelsByPhaseAndPhaseGroup({
    selectedFase,
    selectedFaseGroup,
  })

  return `${level}${
    level === 'PAUD' && selectedFaseGroup === 'Umum'
      ? ''
      : phaseGroupPostFix[selectedFaseGroup]
  }`
}

export const parseSchoolLevel = (schoolLevel: TSchoolLevel): string => {
  if (schoolLevel?.includes('sederajat')) return ''
  if (['SMK', 'PAUDLB', 'PAUD'].includes(schoolLevel))
    return ` • ${schoolLevel}`
  return ' • SLB'
}
